import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ActiveUserInfo } from '../../models';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ActiveUserService {
  private readonly activeUserSubject = new BehaviorSubject<ActiveUserInfo>(null);
  public activeUser$: Observable<ActiveUserInfo> = this.activeUserSubject.asObservable();

  private jwtService = inject(JwtHelperService);
  private localStorageService = inject(LocalStorageService);

  constructor() {
    this.setActiveUser();
  }
  private isGuestSubject = new BehaviorSubject<boolean>(this.localStorageService.checkIsGuest());
  isGuest$ = this.isGuestSubject.asObservable();
  getActiveUser = (): ActiveUserInfo | null => {
    try {
      const token = this.localStorageService.getToken();
      if (!token) {
        this.localStorageService.clearTokens();
        return null;
      }

      const userInfo = this.jwtService.decodeToken(token);
      // console.log("active user info :" + JSON.stringify(userInfo));
      if (!userInfo) {
        this.localStorageService.clearTokens();
        return null;
      }

      return userInfo as ActiveUserInfo;
    } catch (error) {
      this.localStorageService.clearTokens();
      return null;
    }
  };
  updateGuestStatus() {
  const isGuest = this.localStorageService.checkIsGuest();
  this.isGuestSubject.next(isGuest);
}
  checkRegisterUser() {
    if (this.getActiveUser()) {
      if (this.localStorageService.checkIsGuest()) {
        return false;
      }
      return true;
    }
    return false;
  }
  setActiveUser = (): void => this.activeUserSubject.next(this.getActiveUser());

  clearActiveUser = () => this.activeUserSubject.next(null);
}
